export const datatable = {
  colorScheme: {
    light: {
      // header: {
      //   background: '{primary.500}',
      //   color: 'black',
      //   borderColor: '{primary.400}',
      // },
      // headerCell: {
      //   color: '{text.color}',
      // },
      body: {
        //   background: 'red',
        // color: '#333',
        //   borderColor: '#5B5F69',
        //   cell: {
        //     background: 'red',
        //     color: '#aeb5b7',
        //     borderColor: '#5B5F69',
        //   },
        // },
        // row: {
        //   background: 'red',
        //   hoverBackground: '{primary.50}',
        //   borderColor: 'blue',
      },
      row: {
        // background: '#3C434F',
        color: '#0e2a4a',
        // Por defecto PrimeNG usa {surface.100}, que en este tema es '#eef4f7':
        // sobre el blanco de la fila casi no se nota. Este tono es lo más
        // flojo que se sigue distinguiendo sobre el blanco.
        hoverBackground: '#eef4f7',
        // Ya no hay rayado (ver comentario en `css` de abajo) -- transparent
        // para que una tabla con [stripedRows] a mano (mecanismo propio de
        // PrimeNG, aparte del nuestro) tampoco pinte nada distinto.
        stripedBackground: 'transparent',
      },
    },
    dark: {
      header: {
        background: '#3C434F',
        color: '#aeb5b7',
        borderColor: '#5B5F69',
        cell: {
          background: '#3C434F',
          color: '#aeb5b7',
          borderColor: '#5B5F69',
          selected: {
            color: '#c9cecf', // Texto del filtro en blanco
          },
        },
      },
      headerCell: {
        color: '{text.color}',
        selectedBackground: '{primary.400}',
        hoverBackground: '{primary.300}',
        hoverColor: '{neutral.50}',
      },
      body: {
        background: '#3C434F',
        color: '#aeb5b7',
        borderColor: '#5B5F69',
        cell: {
          background: '#323743',
          color: '#aeb5b7',
          borderColor: '#5B5F69',
        },
      },
      row: {
        background: '#3C434F',
        color: '#aeb5b7',
        // {primary.800} ('#002132') queda casi negro sobre estas filas: el
        // salto era demasiado brusco para un simple "estás aquí". Un tono un
        // poco más claro que la propia fila se lee mejor y molesta menos.
        hoverBackground: '#434b59',
        borderColor: '#363c47',
        // Ya no hay rayado (ver comentario en `css` de abajo) -- mismo tono
        // que la propia fila para que una tabla con [stripedRows] a mano
        // tampoco pinte nada distinto.
        stripedBackground: '#3C434F',
        selected: {
          background: '#333842',
          color: '#c9cecf', // Texto del filtro en blanco
        },
      },
    },
  },
  css: ({ dt }: { dt: (key: string) => string }) => `
    .p-datatable {
      border-radius: 12px;
      overflow: hidden;
    }

    /*
     * Resalte al pasar el ratón en TODAS las tablas de la aplicación.
     *
     * Antes también había rayado (fondo alterno en filas pares/impares) para
     * localizar una fila más fácilmente, pero desde que existe este hover ya
     * no hace falta -- y con todas las filas en blanco se lee más limpio. Se
     * quitó de aquí mismo (antes eran dos reglas, rayado + hover) y de los
     * tokens \`stripedBackground\` de arriba, que se dejan a \`transparent\`
     * en vez de borrarlos por si alguna tabla usa el \`[stripedRows]\` propio
     * de PrimeNG en vez de depender de este tema.
     *
     * PrimeNG solo pinta el hover si cada tabla declara [rowHover], y son más
     * de cincuenta tablas: basta con que a una se le olvide (o que la
     * siguiente que se añada no lo lleve) para que se pierda la uniformidad.
     * Se hace aquí, en el tema, para que valga para todas y para las que
     * vengan.
     *
     * Una tabla puede quedarse fuera poniendo la clase \`plain-rows\` en su
     * \`<p-table>\`: los listados de alarmas y el de instalaciones ya pintan las
     * filas por su cuenta (estado, severidad, iconos).
     */
    p-table:not(.plain-rows) .p-datatable .p-datatable-tbody > tr:not(.p-datatable-row-selected):hover {
      background: ${dt('datatable.row.hover.background')};
      color: ${dt('datatable.row.hover.color')};
    }

    .p-datatable-header {
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
    }

    .p-datatable-footer {
      border-bottom-left-radius: 12px;
      border-bottom-right-radius: 12px;

    }
  `,
};
